import { render, staticRenderFns } from "./PlanTable.vue?vue&type=template&id=790f8f55&scoped=true"
import script from "./PlanTable.vue?vue&type=script&lang=js"
export * from "./PlanTable.vue?vue&type=script&lang=js"
import style0 from "./PlanTable.vue?vue&type=style&index=0&id=790f8f55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790f8f55",
  null
  
)

export default component.exports